Ext.define('SA.HistogramResult', {
    statics: {
        withoutData({reason}) {
            return new SA.HistogramResult({noDataReason: reason});
        }
    },

    constructor({data, noDataReason}) {
        this.data = data;
        this.noDataReason = noDataReason;
    },

    getData() {
        return this.data;
    },

    getNoDataReason() {
        return this.noDataReason;
    },

    hasData() {
        return !!this.getData();
    }
});